(function() {
    'use strict';

    angular.module('competence')
        .controller('CompetenceCreateController', CompetenceCreateController);

    CompetenceCreateController.$inject = ['$state', 'notificationSrvc', 'competenceDataSrvc', 'competenceMessagesConst', 'productCountryConst', 'errorNotificationSrvc'];

    function CompetenceCreateController($state, notificationSrvc, competenceDataSrvc, competenceMessagesConst, productCountryConst, errorNotificationSrvc) {
        var self = this;

        self.serverErrors = {
            name_pl: [],
            name_en: [],
            name_de: [],
            name_cpen: [],
            name_cpde: [],
            country: [],
            reclamation: [],
            complaint_reason: [],
            negotiations: [],
            nonFieldErrors: []
        };
        self.competenceData = {
            name_pl: '',
            name_de: '',
            name_en: '',
            name_cpde: '',
            name_cpen: '',
            country: '',
            reclamation: '',
            complaint_reason: '',
            negotiations: ''
        };
        self.countriesList = productCountryConst;

        self.createGroup = createGroup;
        self.cleanErrors = cleanErrors;

        function createGroup() {
            competenceDataSrvc.create(
                self.competenceData
            ).$promise.then(
                function(response) {
                    notificationSrvc.notification("success", competenceMessagesConst.add);
                    $state.go('layout.competence.list');
                },
                function(response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                }
            );
        }

        function cleanErrors(key) {
            self.serverErrors[key] = [];
        }

    }
})();
